import { render, staticRenderFns } from "./productsModal.vue?vue&type=template&id=19df9494&"
import script from "./productsModal.vue?vue&type=script&lang=js&"
export * from "./productsModal.vue?vue&type=script&lang=js&"
import style0 from "./productsModal.vue?vue&type=style&index=0&id=19df9494&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports